import { render, staticRenderFns } from "./SmtpRelayGroups.vue?vue&type=template&id=d898b692&scoped=true"
import script from "./SmtpRelayGroups.vue?vue&type=script&lang=js"
export * from "./SmtpRelayGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d898b692",
  null
  
)

export default component.exports